import { Link, useNavigate } from 'react-router-dom';

export default function ChooseMode({ onSelect, onCancel, onRoadTo }) {
return (
  <div className="bg-brand-dark py-1">
    <div className="container py-4">
      <h3 className="brand-title text-center mb-5">Con quale modalità vuoi partecipare?</h3>

      <div className="row g-4 justify-content-center">
        <div className="col-md-6">
          <button
            className="btn btn-outline-brand-primary-light w-100 p-4 text-start rounded-4 shadow-sm hover-shadow transition"
            onClick={() => onSelect('indipendente')}
          >
            <h5 className="brand-title fw-bold mb-2 text-center text-brand-primary-ultralight">Indipendente</h5>
            <p className="mb-0 text-muted-brand text-center">
              Crea la tua fazione acquistando liberamente i wrestler con i <strong className="text-brand-primary-ultralight">fantacrediti</strong>. <br />
            </p>
          </button>
        </div>

        <div className="col-md-6 mb-4">
          <button
            className="btn btn-outline-brand-secondary w-100 p-4 text-start rounded-4 shadow-sm hover-shadow transition"
            onClick={() => onSelect('competitivo')}
          >
            <h5 className="brand-title fw-bold mb-2 text-center">Competitivo</h5>
            <p className="mb-0 text-muted-brand text-center">
              Ottieni i tuoi wrestler <strong className="brand-title fw-bold mb-2 text-center">all'asta </strong>e sfida i tuoi amici.
            </p>
          </button>
        </div>

        <div className="col-sm-6 text-center">
          <Link to="/rules" className="btn btn-outline-secondary text-light flex-grow-1">
            <i className="bi bi-journal-text me-2"></i> Leggi le regole
          </Link>
        </div>
      </div>
    </div>
  </div>
);

}
